module.exports = __webpack_public_path__ + "img/dc.29b823e0.png";